import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "new72",
  "use": "new72-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"new72\"><defs><style>#new72 .cls-1{fill:none}</style></defs><title>资源 77</title><g id=\"new72_图层_2\" data-name=\"图层 2\"><g id=\"new72_图层_1-2\" data-name=\"图层 1\"><g id=\"new72_arrowright\"><path id=\"new72_Shape\" d=\"M4 11h13.46l-5.07-4.91a1 1 0 0 1 1.43-1.49l6.91 6.64a1 1 0 0 1 0 1.46l-7 6.67a1 1 0 0 1-1.43-1.48L17.42 13H4a1 1 0 0 1-1-1 1 1 0 0 1 1-1z\" /></g><path id=\"new72_Rectangle_37_Copy\" data-name=\"Rectangle 37 Copy\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/new72.svg
// module id = USPB
// module chunks = 6